import { createContext } from "react";

interface HubspotContextProps {
  identifyHubspotUser: (
    email: string,
    firstName?: string,
    lastName?: string,
  ) => void;
}

const HubspotContext = createContext<HubspotContextProps | null>(null);

export default HubspotContext;
